import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import './Login.css';
function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/admin-auth/login', { email, password });
      localStorage.setItem('saskara_admin_token', res.data.token);
      localStorage.setItem('saskara_admin_info', JSON.stringify(res.data.admin));
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Gagal login');
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="login-page">
      <form className="login-card" onSubmit={handleSubmit}>
        <div className="login-brand">
          <img src="/logo.png" alt="Saskara Record" className="login-brand-img" />
          SASKARA<span>RECORD</span>
        </div>
        <p className="login-subtitle">Admin Dashboard</p>
        {error && <div className="login-error">{error}</div>}
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? 'Memproses...' : 'Login'}
        </button>
      </form>
    </div>
  );
}
export default Login;
